import React, {useLayoutEffect} from 'react'
import { useLoader } from '@react-three/fiber'
import * as THREE from "three"
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader'
import model from "../../../Assets/Door/door.fbx"
import aoTex from "../../../Assets/Door/doorAo.jpeg"
import normalTex from "../../../Assets/Door/glass_normal.png" 
import { useTexture, useCubeTexture } from '@react-three/drei'
// import { useControls } from 'leva'

const Door = ({size}) => {


    const [aoMap, normalMap] = useTexture([aoTex, normalTex]);
    const envMap = useCubeTexture(['Right3.jpg', 'Left3.jpg', 'Top3.jpg', 'Bottom3.jpg', 'Front3.jpg', 'Back3.jpg'], { path: 'Cube/type1-center/' })
    // aoMap.flipY = false
    aoMap.encoding = THREE.RGBFormat
    normalMap.wrapS = normalMap.wrapT = THREE.RepeatWrapping
    normalMap.repeat.set(100, 100)

    const glassMaterial = React.useMemo(() => new THREE.MeshPhongMaterial({
        aoMap : aoMap,
        aoMapIntensity: 0.4,
        envMap : envMap,
        color : new THREE.Color('#688684').convertSRGBToLinear(),
        reflectivity : 0.75,
        normalMap : normalMap
    }), [aoMap, envMap, normalMap])

    const frameMaterial = React.useMemo(() => new THREE.MeshPhongMaterial({
        aoMap : aoMap,
        aoMapIntensity: 0.1,
        envMap : envMap,
        map : aoMap,
        reflectivity : 0.75,
        color : new THREE.Color('#595957').convertSRGBToLinear(),
    }), [aoMap, envMap])
    

    const fbx = useLoader(FBXLoader, model)
    useLayoutEffect(() => {
        fbx.traverse(function(child){
            if(child.isMesh){
                if(child.name === 'Glass'){
                    child.material = glassMaterial
                } else{
                    child.material = frameMaterial
                }
            }
        })
    }, [fbx, glassMaterial, frameMaterial])

    return (
        <primitive
            object={fbx} 
            position={[-(size+48)/2, 0, 0]} 
            rotation={[0, Math.PI, 0]}
            // scale={[0.5, 0.5, 0.5]}
        />
    )
}

export default Door
